export enum TextureAssetNames {
	Template = "template",
	InteractiveIntersection = "interactive-intersection",
	ClampUp = "clamps1",
	ClampRight = "clamps2",
	ClampDown = "clamps3",
	ClampLeft = "clamps4",

	CrossIntersection = "intersection1",
	TripleIntersectionDown = "intersection2",
	TripleIntersectionLeft = "intersection3",
	TripleIntersectionUp = "intersection4",
	TripleIntersectionRight = "intersection5",
	BendIntersectionUp = "intersection6",
	BendIntersectionRight = "intersection7",
	BendIntersectionDown = "intersection8",
	BendIntersectionLeft = "intersection9",
	BarIntersectionUp = "intersection10",
	BarIntersectionRight = "intersection11",
	SingleIntersectionUp = "intersection12",
	SingleIntersectionRight = "intersection13",
	SingleIntersectionDown = "intersection14",
	SingleIntersectionLeft = "intersection15",

	PipeHorizontalEmpty = "pipe-horizontal1",
	PipeHorizontalFull = "pipe-horizontal2",
	PipeHorizontalAnimationFrame1 = "pipe-horizontal3",
	PipeHorizontalAnimationFrame2 = "pipe-horizontal4",
	PipeHorizontalAnimationFrame3 = "pipe-horizontal5",
	PipeVerticalEmpty = "pipe-vertical1",
	PipeVerticalFull = "pipe-vertical2",
	PipeVerticalAnimationFrame1 = "pipe-vertical3",
	PipeVerticalAnimationFrame2 = "pipe-vertical4",
	PipeVerticalAnimationFrame3 = "pipe-vertical5",

	GloopPortSingleEmpty = "gloop-port1",
	GloopPortSingleFull = "gloop-port2",
	GloopPortDoubleEmpty = "gloop-port3",
	GloopPortDoubleHalf = "gloop-port4",
	GloopPortDoubleFull = "gloop-port5",
	GloopPortTripleEmpty = "gloop-port6",
	GloopPortTripleOne = "gloop-port7",
	GloopPortTripleTwo = "gloop-port8",
	GloopPortTripleFull = "gloop-port9",
	GloopPortSyphonEmpty = "gloop-syphon1",
	GloopPortSyphonFull = "gloop-syphon2",

	Engine = "engines",
	StorageRoom = "storage",
	NavigationRoom = "feature-radar",
	ThrustersRoom = "feature-control",
	ReactorRoom = "feature-reactor",

	Ship = "ship",
	Moon = "moon",
	Saturn = "saturn",
	Earth = "earth",

	BoxIcon = "box-icon",
}
